import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border text-muted-foreground">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="space-y-4">
            <img
              src="/lovable-uploads/050bb7dc-9bdc-48e5-893c-7150aba3caf6.png"
              alt="Loch Ness Story"
              className="h-12 w-auto"
            />
            <p className="text-sm leading-relaxed">
              Documenting sightings, research, and the enduring characters behind Scotland's most famous mystery.
            </p>
            <a
              href="mailto:simondawes7@gmail.com"
              className="inline-flex items-center gap-2 text-sm text-accent hover:text-accent/80 transition-colors"
            >
              <Mail className="w-4 h-4" />
              simondawes7@gmail.com
            </a>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-semibold text-foreground mb-4 text-sm tracking-wider uppercase">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/blog" className="hover:text-foreground transition-colors">Articles & Sightings</Link></li>
              <li><Link to="/blog" className="hover:text-foreground transition-colors">Articles</Link></li>
              <li><Link to="/research" className="hover:text-foreground transition-colors">Research</Link></li>
              <li><Link to="/about" className="hover:text-foreground transition-colors">About Nessie</Link></li>
            </ul>
          </div>

          {/* Featured */}
          <div>
            <h4 className="font-semibold text-foreground mb-4 text-sm tracking-wider uppercase">Featured</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/blog/20-most-credible-lake-monster-sightings" className="hover:text-foreground transition-colors">20 Most Credible Sightings</Link></li>
              <li><Link to="/blog/sandra-mansi-photograph-lake-champlain" className="hover:text-foreground transition-colors">The Sandra Mansi Photo</Link></li>
              <li><Link to="/blog/do-lake-monsters-only-appear-to-certain-people" className="hover:text-foreground transition-colors">Do Monsters Choose Who Sees Them?</Link></li>
              <li><Link to="/blog/visiting-loch-ness-top-attractions-beyond-nessie" className="hover:text-foreground transition-colors">Visiting Loch Ness Guide</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-foreground mb-4 text-sm tracking-wider uppercase">Legal</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-foreground transition-colors">Terms of Service</Link></li>
            </ul>
            <div className="mt-8">
              <a
                href="https://www.youtube.com/@LochNessStories"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:text-foreground transition-colors"
              >
                YouTube Channel →
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 text-sm text-center text-muted-foreground/60">
          <p>&copy; {new Date().getFullYear()} Loch Ness Story. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
